import React, { memo, useEffect, useState } from "react";
import { useStopModels} from "../../../../store/Apis/ConversationApi";
import SignalRService from "../../../one-query/services/SignalRService";
import "./expertFinds.css";
import "./OneQueryInput.css";
import { OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import { StopModelsRequestParams } from "../../../../Helper";

const StopResponse = memo((Props: any) => {
  const { modelName, isStopAll , place} = Props;
  const stopModelsRequest = useStopModels();
  const [imageSrc, setImageSrc] = useState("/StopResponse/StopResponseAll.svg"); // Default image

  const handleMouseEnter = () => {
    setImageSrc("/StopResponse/StopResponseAllHover.svg"); // Image for hover state
  };

  const handleMouseLeave = () => {
    setImageSrc("/StopResponse/StopResponseAll.svg"); // Back to default image
  };
  const handleStopResponse =async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    const paramAll: Record<string, boolean> = {
      StopChatGPT: true,
      StopGemini: true,
      StopLlama: true,
      StopAnthropic: true,
      StopMistralAi: true,
      StopHuggingFace: true,
      StopNvidia:true,
      StopAlibaba:true,
      StopMicrosoft:true,
      StopDeepSeek:true,
    };
    const paramsAll: StopModelsRequestParams = {
      connectionId,
      param: paramAll,
    };
    if (isStopAll) {
      stopModelsRequest(paramsAll);
    } else {
      let paramKey: string = `Stop${modelName}`;
      const oneParam: StopModelsRequestParams = {
        connectionId,
        param: { [paramKey]: true },
      };

      stopModelsRequest(oneParam);
    }
  };

    const renderTooltip =
    (tooltipText: string | undefined) => (props: TooltipProps) => {
      return tooltipText !== "" && place != "user-input"  ? (
        <Tooltip className="stop-response-tooltip" id="dropdown-item-tooltip" {...props}>
          <span className="persona-item-overlay">{tooltipText}</span>
        </Tooltip>
      ) : (
        <div></div>
      );
    };

  return (
    <div className=" d-flex c-pointer position-relative" onClick={handleStopResponse}>
      <OverlayTrigger 
          placement="right"
          delay={{ show: 250, hide: 300 }}
          overlay={renderTooltip("Stop response")}>
          <img
            className="c-pointer stop-response gap-1"
          src={imageSrc}
          alt="Stop Response"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        </OverlayTrigger>
    </div>
  
  );
});

export default StopResponse;
